module.exports = __webpack_public_path__ + "static/media/EndEvent.9912d461.svg";